import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"

const query = graphql`
	query useImageData {
		allFile(filter: {relativeDirectory: {eq: "Cropped-Images"}}) {
			edges {
				node {
					childImageSharp {
						gatsbyImageData (
							placeholder: BLURRED
							formats: [AUTO, WEBP, AVIF, JPG]
						)
					}
					name
				}
			}
		}
	}
`

const useImageData = () => {
	const data = useStaticQuery(query)

	const result = Object.fromEntries(
		data.allFile.edges
			.map(x => x.node)
			.map(x => [x.name, getImage(x)]))

	return result
}

export default useImageData
